<template>
  <div class="page-account">
    <div class="page-account-content">
      <div class="content-top">
        <h1 class="content-header">财务系统（服务商）</h1>
        <div class="content-desc">Finance Management System</div>
      </div>
      <div class="content-main">
        <el-form
          ref="form"
          :model="form"
          label-width="0"
          status-icon
          :rules="rules"
        >
          <div class="flex items-center">
            <div class="jr_login_type_item" :class="{'jr_login_type_item_active':loginType==='password'}" @click="handleChangeLoginType('password')">密码登录</div>
            <div class="jr_login_type_item" :class="{'jr_login_type_item_active':loginType==='phone'}" @click="handleChangeLoginType('phone')">免密登录</div>
          </div>
          <template v-if="loginType==='phone'">
            <el-form-item prop="phone">
              <el-input
                v-model="form.phone"
                placeholder="请输入手机号码"
                maxlength="11"
              >
                <i slot="prefix" class="el-input__icon el-icon-user"></i>
              </el-input>
            </el-form-item>
            <el-form-item prop="smsCode">
              <div class="flex flex-justify-between">
                <el-input
                  v-model="form.smsCode"
                  maxlength="8"
                  placeholder="请输入验证码"
                  autocomplete="off"
                >
                  <i slot="prefix" class="el-input__icon el-icon-unlock"></i>
                  <el-button
                    slot="append"
                    type="primary"
                    style="min-width: 96px;padding: 12px; color: #ffa141;"
                    :disabled="disabled"
                    @click="getCode"
                  >{{btnText}}</el-button>
                </el-input>
              </div>

            </el-form-item>
            <el-form-item v-if="needCode">
              <el-row :gutter="10">
                <el-col :span="18">
                  <el-input v-model="form.imageCode" placeholder="请输入验证码"></el-input>
                </el-col>
                <el-col :span="6" style="height: 40px">
                  <img :src="imageCodeUrl" alt style="height: 100%;width: 100%" @click="handleChangeCode" />
                </el-col>
              </el-row>
            </el-form-item>
          </template>
          <template v-else>
            <el-form-item prop="username">
              <el-input v-model="form.username" placeholder="用户名">
                <i slot="prefix" class="el-input__icon el-icon-user"></i>
              </el-input>
            </el-form-item>

            <el-form-item prop="password">
              <el-input
                type="password"
                v-model="form.password"
                placeholder="密码"
                @keyup.enter.native="handleSubmit"
              >
                <i slot="prefix" class="el-input__icon el-icon-unlock"></i>
              </el-input>
            </el-form-item>
            <el-form-item prop="imageCode" v-if="needCode">
              <el-row :gutter="10">
                <el-col :span="18">
                  <el-input v-model="form.imageCode" placeholder="请输入验证码"></el-input>
                </el-col>
                <el-col :span="6" style="height: 40px">
                  <img :src="imageCodeUrl" alt style="height: 100%;width: 100%" @click="handleChangeCode" />
                </el-col>
              </el-row>
            </el-form-item>
          </template>

          <el-form-item>
            <el-button
              class="button-block"
              type="primary"
              @click="handleSubmit"
              :loading="loading"
            >登录</el-button>
          </el-form-item>

        </el-form>
        <div class="forget" v-if="loginType!=='phone'">
          <span @click="toForget">忘记密码</span>
        </div>
      </div>
    </div>
    <div class="page-account-footer">
      <div class="footer-copyright">{{ copyright }}</div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
// import { validateMin } from '@/utils/validate-rules';
import { COPYRIGHT, getEnv } from '@/config';
// eslint-disable-next-line import/no-cycle
import { getRefreshImageCode, loginSmsCode, getLoginImageCode } from '@/api/account';
import { validateMobile } from '@/utils/validate-rules';
import { isMobile } from '@/utils/validate';

export default {
  name: 'Login',
  data() {
    return {
      copyright: COPYRIGHT,
      rules: {
        username: [
          { required: true, message: '用户名不能为空', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          // { validate: validateMin, min: 6, message: '密码长度不能小于6位数', trigger: 'blur' },
        ],
        imageCode: [
          { required: true, message: '验证码不能为空', trigger: 'blur' },
        ],
        phone: [
          { required: true, message: '手机号不能为空', trigger: 'blur' },
          { validate: validateMobile, min: 11, message: '手机号码格式不对', trigger: 'blur' },
        ],
        smsCode: [
          { required: true, message: '验证码不能为空', trigger: 'blur' },
        ],
      },
      form: {
        username: '',
        password: '',
        auto: true,
        imageCode: '',

        phone: '',
        smsCode: '',
      },
      loading: false,
      needCode: false,
      imageCodeUrl: '',
      loginType: 'password',


      /** -------免密登录-------- */
      btnText: '获取验证码',
      disabled: false,
      count: 60,
      timer: null,
    };
  },
  methods: {
    handleChangeLoginType(val) {
      this.loginType = val || 'password';
      this.needCode = false;
      this.imageCodeUrl = '';
      this.form.imageCode = '';
      if (val === 'phone') {
        this.btnText = '获取验证码';
        this.disabled = false;
        this.count = 60;
        clearInterval(this.timer);
      }
      this.$refs.form.clearValidate();
    },
    async getCode() {
      if (!this.form.phone) {
        this.$message.warning('手机号不能为空');
        return;
      }
      if (!isMobile(this.form.phone)) {
        this.$message.warning('手机号码格式不对');
        return;
      }
      if (this.needCode && !this.form.imageCode) {
        this.$message.warning('图片验证码不能为空');
        return;
      }
      try {
        this.setTimer();
        await loginSmsCode({
          imageCode: this.form.imageCode,
          phone: this.form.phone,
          type: 2, // 验证码类型(1/忘记密码   2/手机短信登录)
          fromClient: 'service-provider-client', // 信息模版固定参数
        });
        // 发短信图片code拦截,返回成功后清空图片验证信息
        this.needCode = false;
        this.imageCodeUrl = '';
        this.form.imageCode = '';
      } catch (error) {
        clearInterval(this.timer);
        this.btnText = '获取验证码';
        this.disabled = false;
        const { subCode } = error;
        // 图形验证码,300004需要验证码，300005验证码错误
        if (['300004', '300005'].includes(subCode)) {
          this.needCode = true;
          this._getLoginImageCode();
        }
        console.log(error);
      }
    },
    setTimer() {
      let num = 60;
      this.btnText = `${num}S`;
      this.timer = setInterval(() => {
        num -= 1;
        this.btnText = `${num}S`;
        this.disabled = true;
        if (num === 0) {
          this.btnText = '获取验证码';
          this.disabled = false;
          clearInterval(this.timer);
        }
      }, 1000);
    },

    ...mapActions('account', ['loginByUsername', 'loginBySms']),
    handleSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.loading = true;
          try {
            let res = {};
            // 免密登录
            if (this.loginType === 'phone') {
              const { phone, smsCode } = this.form;
              const params = {
                phone, // 手机号
                smsCode, // 短信验证码
                applicationCode: '4', // 应用编号
              };
              res = await this.loginBySms(params);
            } else {
              // 密码登录
              const { username, password, imageCode = '' } = this.form;
              const params = {
                userKey: username,
                passWord: password,
                imageCode,
                applicationCode: '4',
              };
              res = await this.loginByUsername(params);
            }
            if (res.success) {
              if (process.env.NODE_ENV === 'production' && getEnv() === 'prod') {
                this.$bl.setConfig({
                  uid: res.data.userId,
                  setUsername() {
                    return `username_${res.data.userName}`;
                  },
                });
              }
              const redirectUrl = this.$route.query.redirect ? decodeURIComponent(this.$route.query.redirect) : '/';
              this.$router.replace(redirectUrl);
            } else {
              this.$message.error(res.message || '登录失败，请重试');
            }
          } catch (error) {
            const { subCode } = error;
            // 图形验证码,300004需要验证码，300005验证码错误
            if (['300004', '300005'].includes(subCode)) {
              this.needCode = true;
              if (this.loginType === 'phone') {
                this._getLoginImageCode();
              } else {
                this._getRefreshImageCode();
              }
            }
          } finally {
            this.loading = false;
          }
        }
      });
    },
    toForget() {
      this.$router.push({
        name: 'ForgotPwd',
      });
    },
    // 密码登录-登录图片验证码
    async _getRefreshImageCode() {
      const res = await getRefreshImageCode({ userKey: this.form.username });
      this.imageCodeUrl = res.data || '';
    },

    // 免密登录-登录图片验证码
    async _getLoginImageCode() {
      const res = await getLoginImageCode({ phone: this.form.phone });
      this.imageCodeUrl = res.data || '';
    },
    // 切换图片code
    handleChangeCode() {
      if (this.loginType === 'phone') {
        this.$refs.form.validateField('phone', (error) => {
          if (!error) {
            this._getLoginImageCode();
          }
        });
        return;
      }
      this.$refs.form.validateField('username', (error) => {
        if (!error) {
          this._getRefreshImageCode();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./account.scss";

.forget {
  display: flex;
  justify-content: end;
  align-items: center;
  span{
    cursor: pointer;
  }
}
.jr_login_type_item {
  font-size: 18px;
  font-weight: bolder;
  margin-bottom: 32px;
  margin-right: 32px;
  cursor: pointer;
}
.jr_login_type_item_active {
  color: #ffa141;
  &::after {
    content: "";
    display: block;
    width: 45px;
    height: 3px;
    background: #ffa141;
    position: relative;
    margin: 0 auto;
    top: 10px; /* 调整这个值可以改变下划线的垂直位置 */
  }
}
</style>
